import { PageType } from '../types/generatedTypes';

// Page type constants - single source of truth from backend enum
export const PAGE_TYPES = {
  DANEL: 'danel' as PageType,
  OTC: 'otc' as PageType,
  OTC_DATABASE: 'otc_database' as PageType,
  PORTFOLIO: 'portfolio' as PageType,
  CUSTODIAN: 'custodian' as PageType,
  HOLDINGS: 'holdings' as PageType,
} as const;

// Helper to get all page types as array
export const ALL_PAGE_TYPES: PageType[] = Object.values(PAGE_TYPES);
